import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getPriceResults } from '@/redux/modules/priceResults/priceResults.actions';
import { getUpcomingSort } from '@/redux/modules/priceResults/priceResults.selectors';
import { Select } from '@liveauctioneers/hammer-ui-core/select';
import { UpcomingSortKeys } from '@/redux/modules/priceResults/priceResults.types';
import { updateUpcomingSort } from '@/redux/modules/priceResults/priceResults.reducer';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

type Props = {
    itemId: number;
    slug: string;
};

export const UpcomingSort = ({ itemId, slug }: Props) => {
    const dispatch = useAppDispatch();
    const currentSort = useAppSelector(getUpcomingSort);

    const sortOptions = [
        UpcomingSortKeys.BestMatch,
        UpcomingSortKeys.NewlyListed,
        UpcomingSortKeys.MostBids,
        UpcomingSortKeys.EstimateHighest,
        UpcomingSortKeys.PriceHighest,
        UpcomingSortKeys.PriceLowest,
    ].map((sort) => ({
        label: <FormattedMessage id={`sorts.${sort}`} />,
        value: sort,
    }));

    return (
        <Select
            className="relative w-[260px] py-sm xsMax:w-full"
            instanceId="search_sort"
            isInsideLabel
            labelText={<FormattedMessage id="search_sort" />}
            onChange={({ value }) => {
                dispatch(updateUpcomingSort(value as unknown as UpcomingSortKeys));
                dispatch(getPriceResults({ itemId, slug }));
            }}
            options={sortOptions}
            small
            value={sortOptions.find((op) => op.value === currentSort)}
        />
    );
};
